import { authenticatedRequest } from "./api.service";
import { CompetencyTestType } from "../typings/competency-test";

export const competencyService = {
  getMy: async (code: string): Promise<{data: CompetencyTestType[]}> => {
    const response = await authenticatedRequest("GET", "/competency-test/my", {
      code,
      full: true,
    });
    return response as unknown as { data: CompetencyTestType[] };
  },

  getAll: async (code: string): Promise<CompetencyTestType> => {
    const response = await authenticatedRequest(
      "GET",
      "/competency-test/list",
      {
        code,
        full: true,
      }
    );
    return response as unknown as CompetencyTestType;
  },
};